module.exports = __webpack_public_path__ + "static/arteDeImpactar-593cf90d084eeb68892f231278ab7a40.png";